const USE_CDN = appOptions.useCdn;

const cdnPrefix = appOptions.publicHost + "ajax/libs/";
const localPrefix = "../ajax/libs/";

const libraries = {
    //domReady: "require-domReady/2.0.1/domReady.min",
    "css": "require-css/0.1.10/css.min",
    "tslib": "tslib/2.8.1/tslib.min",

    "jquery": "jquery/3.7.1/jquery.min",
    "jquery-validation": "jquery-validate/1.21.0/jquery.validate.min",

    "nprogress": "nprogress/0.2.0/nprogress.min",

    "swiper": "Swiper/11.0.5/swiper-bundle.min",

    "magnific-popup": "jquery.magnific-popup.min",

    "vanilla-tilt": "vanilla-tilt/1.8.1/vanilla-tilt.min",
    // 打字机
    "Typewriter": "TypewriterJS/2.21.0/core.min",

    "sweetalert2": "sweetalert2/11.22.5/sweetalert2.min",

    "crc-32": "crc-32/1.2.2/crc32.min",

    "spark-md5": "spark-md5/3.0.2/spark-md5.min",

    "lodash-es": "lodash.js/4.17.21/lodash.min",

    "clipboard-polyfill": "clipboard-polyfill/4.1.1/es5/clipboard-polyfill.overwrite-globals.promise.es5.min",

    "dayjs": "dayjs/1.11.18/dayjs.min",

    "Shuffle": "Shuffle/6.1.0/shuffle.min",

    "@popperjs/core": "popper.js/2.11.8/umd/popper.min",

    "prismjs": "prism/1.30.0/prism.min",

    "highlight.js": "highlight.js/11.11.1/highlight.min",
};

// FIX: 修复模块与define 名称不一致的问题
define("typewriter-effect", ["Typewriter"], function (m) { return m; })

// 处理加载的模块
const paths = Object.keys(libraries).map(key => {
    const data = [];
    if (USE_CDN) {
        data.push(cdnPrefix + libraries[key]);
    }
    data.push(localPrefix + libraries[key]);

    return [key, data];
});
paths.push(["@", appOptions.baseUrl + "Scripts"]); // 让ts 文件中可以使用 @ 符号进行引用
//! （这里还没调整，试试） 官方版本未支持到MVC 6.x 的版本，所以此处依据5.x 的版本进行调整适应6.x
paths.push(["jquery-validation-unobtrusive", "framework/jquery.validate.unobtrusive"]);
paths.push(["@bidiao/framework", "../libs/bidiao-framework"]);
paths.push(["@bidiao/captcha", "../libs/captcha"]);

const config = requirejs.config({
    skipDataMain: true,// 通过 data-main 属性加载的脚本文件，不会进行预加载
    //deps: ["jquery", "tslib", "nprogress"],// 可以进行预加载，并行优先加载
    deps: ["jquery", "tslib"],// 可以进行预加载，并行优先加载
    baseUrl: appOptions.baseUrl + "Scripts",
    //map: {
    //    '*': {
    //        css: 'require-css/css'
    //    }
    //},
    //urlArgs: "v=1.0.0",
    urlArgs: (id, url) => {
        // 判断是否依赖的模块，依赖的三方模块可以直接使用缓存内的值
        if (url.startsWith("http://") || url.startsWith("https://")) {
            if (url.endsWith(".css")) {
                return "";
            }
            if (url.endsWith(".js")) {
                return "";
            }

            return ".js";
        }

        return (url.indexOf('?') === -1 ? '?' : '&') + "v=" + appOptions.version;
    },
    waitSeconds: 2000,//加载包时的超时时长，单位为秒。（默认为7秒）
    paths: Object.fromEntries(paths),
    shim: {
        "swiper": {
            deps: [`css!${localPrefix}Swiper/11.0.5/swiper-bundle.min.css`],
            exports: "Swiper"
        },
        "prismjs": {
            exports: "Prism"
        }
        //"sweetalert2": {
        //    deps: [`css!${localPrefix}sweetalert2/11.22.5/sweetalert2.min.css`],
        //}
    }
});

//! 以下代码移植页面中处理了，此处仅进行保留参考
const pageChunks = appOptions.pageChunks || [];
if (appOptions.pageScript) {
    pageChunks.push(appOptions.pageScript);
}

// 提取通过define 注册的内容
const registry = requirejs[config.name].contexts["_"].registry;

// jquery-validation-unobtrusive
require(["jquery", "@bidiao/framework"], function ($: JQueryStatic, biDiaoFramework) {
    $.ajaxSetup({
        "headers": {
            "X-Requested-With": "XMLHttpRequest",
        },
        //"beforeSend": function (jQuery, settings) {
        //    debugger;
        //}
    });
    // 生成客户端标识
    document.cookie = `cid=${biDiaoFramework.Device.getDeviceId()}; max-age=31536000; path=/; SameSite=Lax`;

    $(document).on("click", "[command]", evt => {
        const command = $(evt.currentTarget).attr("command");
        // 如果没有提供 command
        if (!command) {
            return;
        }
        evt.preventDefault();// 禁止默认事件
        // 如果当前对象已经被禁用，或者包裹当前表单对象的form 被禁用，则不触发执行指令
        if ($(evt.currentTarget).prop("disabled") || $(evt.currentTarget).closest("form").prop("disabled")) {
            evt.stopPropagation(); // 禁止冒泡
            evt.stopImmediatePropagation();// 禁止其他监听器的调用
            return;
        }

        //$(evt.currentTarget).triggerHandler(`command.${command}`);
    });
    let pageExportData = {};// 页面导出来的数据

    $(document).on("click", "[ng-click]", function (evt) {
        const $el = $(evt.currentTarget);
        const expr = $el.attr("ng-click");
        if (!expr) {
            return
        }
        evt.preventDefault();// 禁止默认事件
        // 如果当前对象已经被禁用，或者包裹当前表单对象的form 被禁用，则不触发执行指令
        if ($el.prop("disabled") || $el.closest("form").prop("disabled")) {
            evt.stopPropagation(); // 禁止冒泡
            evt.stopImmediatePropagation();// 禁止其他监听器的调用
            return;
        }


        let methodName = expr;
        let args: any[] = [evt];// 默认参数

        // 解析表达式：支持 addToCart 或 confirmThenDelete('msg', 123)
        const match = expr.trim().match(/^(\w+)\((.*)\)$/);
        if (match) {
            // 有参数的情况
            methodName = match[1];
            const rawArgs = match[2];
            args = rawArgs
                ? rawArgs.split(',').map(arg => {
                    arg = arg.trim();
                    // 尝试解析字符串、数字、布尔值
                    if (arg === 'true') return true;
                    if (arg === 'false') return false;
                    if (arg === 'null') return null;
                    if (arg === 'undefined') return undefined;
                    if (!isNaN(+arg)) return +arg; // 数字
                    if (/^['"]/.test(arg)) return arg.slice(1, -1); // 去除引号
                    return arg; // 变量名（可扩展）
                })
                : [];
            const func: Function = pageExportData[methodName] || window["$scope"]?.[methodName] || window[methodName];
            console.log(window["$scope"]?.[methodName]);
            if (!func) {
                console.warn(`未注册的方法: ${methodName}`);
                return;
            }
            func.call(evt.currentTarget, ...args);
        }
        const func: Function = pageExportData[methodName] || window["$scope"]?.[methodName] || window[methodName];
        console.log(window["$scope"]?.[methodName]);
        if (!func) {
            console.warn(`未注册的方法: ${methodName}`);
            return;
        }
        func.call(evt.currentTarget, ...args);

    })


    var promise = Promise.resolve();
    // 页面创建之前进行的加载和处理，此时仅进行了jQuery 的加载
    if (registry["page:before:create"]) {
        // 可以在页面的JS中直接支持写法： define("page:before:created",["jquery"],function(){ });
        promise = new Promise((resolve, reject) => { require(["page:before:create"], resolve, reject); })
    }
    // jquery 完成时候的处理
    promise = promise.then(() => new Promise((resolve) => { $(function () { resolve(); }) }));
    promise = promise.then(() => new Promise((resolve, reject) => {
        require(["framework/index"], ({ createFollowMouse, createPopper, createDetails, createGoTop, createMobileMenu, createSiteSlogan, createPartnerLogos, createTypewriter, createTabs, createToggle }) => {
            //createFollowMouse();// 跟随鼠标
            createGoTop(); // 回到顶部
            createMobileMenu();// 移动端菜单
            createSiteSlogan();// 站点顶部slogan 滚动效果
            createPartnerLogos();// 合作伙伴logo 滚动效果
            createTypewriter();// banner 打字机效果
            createTabs();// tabs能力支持插件
            createToggle();
            createDetails();//给details 组件提供折叠动画的能力，禁止原生显示效果
            createPopper();
            resolve();
        }, reject);
    }));
    // 判断是否有页面对应的模块
    if (pageChunks.length) {
        promise = promise.then(() => new Promise((resolve, reject) => {
            require(pageChunks, (data) => {
                pageExportData = data || {};// 页面导出来的数据
                resolve();
            }, reject);
        }));
    }
    if (registry["page:created"]) {
        // 可以在页面的JS中直接支持写法： define("page:created",["jquery"],function(){ });
        promise = promise.then(() => new Promise((resolve, reject) => { require(["page:created"], resolve, reject); }));
    }
    // 判断是否存在需要渲染的代码块
    const codeElms = document.querySelectorAll('pre[class*="language-"]');
    if (codeElms.length) {
        promise = promise.then(() => new Promise((resolve, reject) => {
            require(["prismjs"], (Prism) => {
                codeElms.forEach(block => {
                    // 高亮代码区域
                    Prism.highlightElement(block, false, () => {
                        // 添加行号
                        const lines = block.innerHTML.split("\n");
                        // 生成带行号的 HTML
                        const numberedLines = lines.map(line => `<li>${line}</li>`).join("");
                        block.innerHTML = "<ol class='line-numbers'>" + numberedLines + "</ol>";
                    });
                });
                resolve();
            }, reject)
        }))
    }
    return promise;
});

